import React from 'react'
import { createRoot } from 'react-dom/client'
import MainImplementation from './MainImplementation'
import { stashTargetDraft } from './deepLink'
import { DEFAULT_WARNING_SECONDS } from './useSessionExpiry'

// What the server bakes into index.html before loading this bundle (web/main.py). Declared rather
// than cast away one use at a time: these are a real, if small, interface between the two halves of
// the app, and naming them here is where a mismatch would show up.
declare global {
    interface Window {
        initiallyLoggedIn: boolean
        // Absent from a document cached from before the setting existed, hence the fallback below.
        sessionWarningSeconds?: number
    }
}

// Before the first render, since what renders depends on being signed in and the link has to
// survive not being.
stashTargetDraft()

const domNode = document.getElementById('root')
if (domNode !== null) {
    const root = createRoot(domNode)
    root.render(<MainImplementation
        initiallyLoggedIn={window.initiallyLoggedIn}
        sessionWarningSeconds={window.sessionWarningSeconds ?? DEFAULT_WARNING_SECONDS}/>)
}
